<template>
    <div id="couponToReceive">
        <div class="coupons stamp stamp01" v-for="item in couponsList" :key="item.id"  @click="receiveAction(item.id)" >
            <div class="par">
                <p class="remark1">{{item.remark}}</p>
                <sub class="sign"></sub>
                <span class="title">{{item.title}}</span>
                <sub></sub>
                <p class="remark2">内置套餐自领取日 {{item.useDay}} 天后失效！</p>
            </div>
            <div class="copy">过期时间<p>2019-10-25</p></div>
            <i></i>
<!--             <div v-if="" class="button-default unClick" >已领取</div>
 -->            
            <div class="button-default">领取</div>
        </div>
    </div>
</template>
<script>
import { wxRequest} from '@/api/user'
export default {
    data(){
        return{
            couponsList: [],
        }
    },
    methods: {

        getCouponsListHandler(disposeState){
            wxRequest("sim/pkg/flowCoupon/list", {}, "post").then(res => {
                if(res.data.code == 200){
                   this.couponsList =  res.data.data;                
                }
            })
        },
        //领取操作
        receiveAction(couponId){
            this.$messagebox.prompt('请输入ICCID号').then(({ value, action }) => {
                if(action == 'confirm'){
                    let data = new FormData();
                    data.append('couponId', couponId);
                    data.append('iccid', value);

                    wxRequest("sim/pkg/flowCouponSim/get", {}, "post").then(res => {
                        this.$messagebox.alert(res.data.message);
                    })
                }
            }).catch(() => {});
        },

    },
    watch:{
        '$route': function(to, from){
            var disposeState = to.query.disposeState;
            this.coupons = [];
            this.getCouponsListHandler(disposeState);            
        }
    },
    created(){
        var disposeState = this.$route.query.disposeState;
        this.getCouponsListHandler(disposeState);
    }    
}
</script>
<style lang="less">
#couponToReceive {

    padding:15px 10px;

    .coupons{
        width:100%;
        margin:10px auto;
        background: radial-gradient(transparent 0, transparent 5px, #F39B00 5px);
        background-size: 15px 15px;
        background-position: 9px 3px;

        .button-default{
            color: #fff;
            position: absolute;
            right: -40px;
            bottom: 10px;
            height: 40px;
            width: 170px;
            text-align: center;
            font-size: 16px;
            line-height: 40px;
            letter-spacing: 2px;
            background-color: rgba(76, 165, 255, 0.8);
            -webkit-transform: rotate(-30deg);
            transform: rotate(-35deg);
            border-radius: 0;
        }

        .unClick{
            color: #ececec;
            background-color: rgba(183, 183, 183, 0.46);
        }
            
    }




    .stamp {
        width: 100%;
        position: relative;
        overflow: hidden;
    }
    .stamp:before {
        content: '';
        position: absolute;
        top:0;
        bottom:0;
        left:10px;
        right:10px;
        z-index: -1;
    }

    .stamp:after {
        content: '';
        position: absolute;
        left: 10px;
        top: 10px;
        right: 10px;
        bottom: 10px;
        box-shadow: 0 0 20px 1px rgba(0, 0, 0, 0.5);
        z-index: -2;
    }
    .stamp i{
        position: absolute;
        left: 20%;
        top: 45px;
        height: 190px;
        width: 390px;
        background-color: rgba(255,255,255,.15);
        transform: rotate(-30deg);
    }
    .stamp .par{
        float: left;
        padding: 16px 15px;
        width: 60%;
        border-right:2px dashed rgba(255,255,255,.3);
        text-align: left;
        box-sizing: border-box;
    }

    .stamp .par p{color:#fff;}
    .stamp .par p.remark1{margin-bottom: 20px;line-height:18px;}
    .stamp .par p.remark2{margin-top: 20px;line-height:18px;}
    .stamp .par span{
        font-size: 24px;
        color:#fff;
        margin-right: 5px; 
    }
    .stamp .par .sign{font-size: 16px;}
    .stamp .par sub{position: relative;top:-2px;color:rgba(255,255,255,.8);}

    .stamp .copy{
        display: inline-block;
        padding:21px 10px;
        width:40%;
        vertical-align: text-bottom;
        font-size: 16px;
        color:rgb(255,255,255);
        box-sizing: border-box;
    }
    .stamp .copy p{font-size: 16px;margin-top: 15px;line-height:20px;}
    .stamp01{
        background: #F39B00;
        background: radial-gradient(rgba(0, 0, 0, 0) 0, rgba(0, 0, 0, 0) 5px, #F39B00 5px);
        background-size: 15px 15px;
        background-position: 9px 3px;
    }
    .stamp01:before{background-color:#F39B00;}


}
</style>
